export const movements = (state) => state.movements //eslint-disable-line
export const showEntryForm = (state) => state.showEntryForm //eslint-disable-line
export const showDepartureForm = (state) => state.showDepartureForm //eslint-disable-line
export const allUsers = (state) => state.allUsers //eslint-disable-line
export const movementSelected = (state) => state.movementSelected //eslint-disable-line
export const stateIsChanged = (state) => state.stateIsChanged
